/* corex-textil-disenos.js · «Mis diseños» del personalizador de camisetas (fase 4).
   - «Guardar diseño»: sube a Cloudinary los originales de las capas que aún no están subidos, el JSON del diseño (el
     mismo del carrito, CorexTextilCart.designDoc) y una miniatura JPG de la vista previa; luego lo guarda en el servicio
     (App Proxy /apps/favoritos/disenos de corex-toptex-sync: metaobject corex_disenos del cliente, máx. 50).
     Con un diseño cargado: «Guardar cambios» (mismo id) o «Guardar como nuevo».
   - Panel «Mis diseños»: Cargar (root.cteApplyDesign; la matriz del pedido no se toca), Renombrar, Borrar (con
     confirmación) y «Usar en otra prenda»: productos personalizador-v2 con plantilla lista; abre el elegido con
     ?diseno=<id>, que carga el diseño al llegar. Antes avisa de las zonas que esa prenda no tiene.
   - Solo con sesión iniciada; sin ella, los botones llevan a iniciar sesión.
   Reglas puras en corex-textil-disenos-model.js. Marcado en snippets/corex-textil-editor.liquid ([data-ctd-*]). */
(function () {
  'use strict';

  var DM = window.CorexTextilDisenosModel, K = window.CorexTextilCart, IO = window.CorexTextilIO;
  var Z = window.CorexTextilZones, PR = window.CorexTextilPrendas;
  if (!DM || !K || !IO || !Z || !PR) return;
  var esc = IO.esc;
  var THUMB_PANEL_PX = 320;
  var THUMB_QUALITY = 0.85;
  var MSG_OK_MS = 6000;
  /* imágenes ya subidas (Cloudinary o, si eran grandes, Vercel Blob): no se vuelven a subir */
  var UPLOADED_RE = /^https:\/\/(res\.cloudinary\.com|[a-z0-9]+\.public\.blob\.vercel-storage\.com|corex-kpi-proxy\.vercel\.app)\//;

  function init(root) {
    if (root.dataset.ctdReady || !root.cteApplyDesign || !root.cteGetDesign) return;
    root.dataset.ctdReady = '1';
    var q = function (s) { return root.querySelector(s); };
    var data;
    try { data = JSON.parse(q('[data-cte-data]').textContent); } catch (e) { return; }
    var cfg = data.disenos || {}, P = data.pedido || {};
    var zoneIds = Z.zonesFor(data.zonas).zonas.map(function (z) { return z.id; });
    var saveSheet = q('[data-ctd-save-sheet]'), listSheet = q('[data-ctd-list-sheet]'), msgEl = q('[data-ctd-msg]');
    var st = { loaded: null, list: null, cupo: null, busy: false, view: 'list', otra: null, prendas: null, open: null, opener: null };
    var uploaded = {};   /* src local (data:) → URL de Cloudinary ya subida (no se repite al volver a guardar) */
    var docs = {};       /* id → JSON del diseño ya descargado */
    var msgTimer = 0;

    /* ---------- sin sesión: los botones invitan a iniciar sesión ---------- */
    if (!cfg.cliente) {
      [q('[data-ctd-open]'), q('[data-ctd-save]')].forEach(function (b) {
        if (!b) return;
        b.textContent = b.hasAttribute('data-ctd-save') ? 'Inicia sesión para guardar tu diseño' : 'Mis diseños (inicia sesión)';
        b.addEventListener('click', function () { window.location.href = cfg.loginUrl || '/account/login'; });
      });
      return;
    }

    /* ---------- servicio ---------- */
    function api(method, params, body) {
      var url = cfg.url + (params ? '?' + new URLSearchParams(params).toString() : '');
      var opts = { method: method, credentials: 'same-origin', headers: { Accept: 'application/json' } };
      if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
      return fetch(url, opts).then(function (res) {
        return res.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { j = null; }
          if (res.ok && j && j.ok) return j;
          var msg = res.status === 401 ? 'Tu sesión ha caducado: vuelve a iniciar sesión para usar «Mis diseños».'
            : (j && j.error) || 'No se ha podido conectar con «Mis diseños» (' + res.status + '). Inténtalo de nuevo.';
          throw IO.userError(msg);
        });
      });
    }
    function setList(j) { st.list = j.disenos; st.cupo = j.cupo; }
    function loadList() {
      return api('GET').then(function (j) { setList(j); return j; });
    }
    function getDoc(d) {
      if (docs[d.id]) return Promise.resolve(docs[d.id]);
      return fetch(d.diseno_url).then(function (res) {
        if (!res.ok) throw IO.userError('No se ha podido descargar el diseño «' + d.nombre + '» (' + res.status + ').');
        return res.json();
      }).then(function (doc) { docs[d.id] = doc; return doc; });
    }

    /* ---------- avisos bajo «Guardar diseño» ---------- */
    function msg(text, kind) {
      clearTimeout(msgTimer);
      msgEl.hidden = !text;
      msgEl.textContent = text || '';
      msgEl.className = 'cte-note ctd-msg' + (kind === 'warn' ? ' cte-note--warn' : kind === 'ok' ? ' cte-note--ok' : '');
      if (kind === 'ok') msgTimer = setTimeout(function () { msgEl.hidden = true; }, MSG_OK_MS);
    }

    /* ---------- hojas (diálogos) ---------- */
    function openSheet(sheet, opener) {
      st.open = sheet;
      st.opener = opener || null;
      sheet.hidden = false;
      document.documentElement.classList.add('cte-noscroll');
      var f = sheet.querySelector('input, button:not([data-ctd-close])') || sheet.querySelector('button');
      if (f) f.focus();
    }
    function closeSheet() {
      if (!st.open || st.busy) return;
      st.open.hidden = true;
      st.open = null;
      document.documentElement.classList.remove('cte-noscroll');
      if (st.opener && document.contains(st.opener)) st.opener.focus();
    }

    /* ---------- guardar ---------- */
    function hasDesign(d) { return Object.keys(d.views || {}).some(function (v) { return d.views[v].on; }); }
    function imageSources(d) {
      var srcs = [];
      Object.keys(d.views).forEach(function (v) {
        d.views[v].prints.forEach(function (p) { p.layers.forEach(function (l) { if (l.type === 'image' && srcs.indexOf(l.src) === -1) srcs.push(l.src); }); });
      });
      return srcs;
    }
    function openSave(opener) {
      var d = root.cteGetDesign();
      if (!hasDesign(d)) return msg('Añade una imagen o un texto antes de guardar el diseño.', 'warn');
      q('[data-ctd-name]').value = st.loaded ? st.loaded.nombre : DM.defaultName(data.title);
      q('[data-ctd-name]').setAttribute('aria-invalid', 'false');
      q('[data-ctd-save-note]').textContent = '';
      var full = st.cupo && st.cupo.lleno;
      q('[data-ctd-save-loaded]').hidden = !st.loaded;
      q('[data-ctd-save-loaded]').textContent = st.loaded ? 'Has cargado «' + st.loaded.nombre + '». Puedes guardar los cambios en él o guardarlo como un diseño nuevo.' : '';
      q('[data-ctd-save-btns]').innerHTML = st.loaded
        ? '<button type="button" class="cte-cta" data-ctd-do="cambios">Guardar cambios</button>' +
          '<button type="button" class="ctd-btn ctd-btn--wide" data-ctd-do="nuevo"' + (full ? ' disabled' : '') + '>Guardar como nuevo</button>'
        : '<button type="button" class="cte-cta" data-ctd-do="nuevo"' + (full ? ' disabled' : '') + '>Guardar</button>';
      if (full) q('[data-ctd-save-note]').textContent = 'Tienes ' + st.cupo.max + ' diseños guardados, el máximo. Borra alguno en «Mis diseños» para guardar uno nuevo.';
      openSheet(saveSheet, opener);
      var input = q('[data-ctd-name]');
      input.focus();
      input.select();
    }
    function saveNote(text, warn) {
      var n = q('[data-ctd-save-note]');
      n.textContent = text;
      n.className = 'cte-note' + (warn ? ' cte-note--warn' : '');
    }
    function setSaveBusy(on) {
      st.busy = on;
      Array.prototype.forEach.call(saveSheet.querySelectorAll('button, input'), function (b) { b.disabled = on; });
    }
    function doSave(mode) {
      var nombre = q('[data-ctd-name]').value.replace(/\s+/g, ' ').trim();
      if (!nombre) {
        q('[data-ctd-name]').setAttribute('aria-invalid', 'true');
        return saveNote('Escribe un nombre para el diseño.', true);
      }
      var d = root.cteGetDesign(), id = mode === 'cambios' && st.loaded ? st.loaded.id : null;
      var gid = 'diseno-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var srcs = imageSources(d), jobs = [];
      srcs.forEach(function (src, i) {
        if (UPLOADED_RE.test(src) || uploaded[src]) return;
        jobs.push({ key: 'orig|' + i, label: 'imagen original ' + (i + 1), publicId: K.publicIds.original(gid, i + 1), name: 'capa-' + (i + 1),
          /* las de más de ~10 MB, a Vercel Blob (textil/disenos/, no caduca; el lienzo las carga con CORS) */
          blobIfLarge: function (b) { return K.blobOriginal(gid, i + 1, b, 'disenos'); },
          make: function () { return fetch(src).then(function (r) { return r.blob(); }); } });
      });
      jobs.push({ key: 'thumb', label: 'miniatura', publicId: K.publicIds.thumb(gid), name: K.publicIds.thumb(gid) + '.jpg',
        make: function () { return root.cteRenderColorPreview(d.color, THUMB_PANEL_PX).then(function (cv) { return K.canvasToBlob(cv, 'image/jpeg', THUMB_QUALITY); }); } });
      jobs.push({ key: 'json', label: 'diseño', publicId: K.publicIds.design(gid) + '.json', name: 'diseno.json', raw: true,
        make: function (urls) {
          srcs.forEach(function (src, i) { if (urls['orig|' + i]) uploaded[src] = urls['orig|' + i]; });
          var doc = K.designDoc({
            d: d, gid: gid, producto: { id: Number(String(root.id).replace('cte-', '')), titulo: data.title, handle: data.handle },
            prenda: data.prenda, zonas: data.zonas,
            srcUrl: function (src) { return UPLOADED_RE.test(src) ? src : uploaded[src]; }
          });
          return Promise.resolve(new Blob([JSON.stringify(doc, null, 1)], { type: 'application/json' }));
        } });
      setSaveBusy(true);
      saveNote('Preparando las fuentes…');
      Promise.resolve(root.cteFontsReady ? root.cteFontsReady() : null).then(function () {
        return K.uploadAll(P.cloudinary, gid, jobs, function (n, total) { saveNote('Subiendo archivos… (' + n + '/' + total + ')'); });
      }).then(function (urls) {
        saveNote('Guardando…');
        var diseno = { nombre: nombre, producto_handle: data.handle, prenda: PR.typeOf(data.prenda), diseno_url: urls.json, preview_url: urls.thumb };
        if (id) diseno.id = id;
        return api('POST', null, { action: 'guardar', diseno: diseno });
      }).then(function (j) {
        setList(j);
        st.loaded = { id: j.diseno.id, nombre: j.diseno.nombre };
        setSaveBusy(false);
        closeSheet();
        var full = j.cupo.lleno ? ' Has llegado al máximo de ' + j.cupo.max + ' diseños guardados: para guardar más, borra alguno.' : '';
        msg((id ? 'Cambios guardados en «' : 'Guardado como «') + j.diseno.nombre + '».' + full, full ? 'warn' : 'ok');
      }).catch(function (err) {
        setSaveBusy(false);
        saveNote(err && err.userFacing ? err.message.replace('; no se ha añadido nada al carrito', '') : 'No se ha podido guardar el diseño (' + (err && err.message) + ').', true);
      });
    }

    /* ---------- panel «Mis diseños» ---------- */
    function prendaLabel(raw) { return PR.get(raw).label; }
    function fecha(iso) {
      var d = new Date(iso);
      return isNaN(d) ? '' : d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    }
    function itemHtml(d) {
      var loaded = st.loaded && st.loaded.id === d.id;
      return '<li class="ctd-item" data-id="' + esc(d.id) + '">' +
        '<img class="ctd-item__img" src="' + esc(d.preview_url) + '" alt="" loading="lazy" width="96" height="64">' +
        '<div class="ctd-item__t"><b>' + esc(d.nombre) + '</b><span class="cte-note">' + esc(prendaLabel(d.prenda)) + ' · ' + esc(fecha(d.fecha)) +
        (loaded ? ' · <strong>cargado</strong>' : '') + '</span></div>' +
        '<div class="ctd-item__acts">' +
        '<button type="button" class="ctd-btn ctd-btn--main" data-ctd-act="cargar">Cargar</button>' +
        '<button type="button" class="ctd-btn" data-ctd-act="renombrar">Renombrar</button>' +
        '<button type="button" class="ctd-btn" data-ctd-act="otra">Usar en otra prenda</button>' +
        '<button type="button" class="ctd-btn ctd-btn--danger" data-ctd-act="borrar">Borrar</button></div>' +
        '<div class="ctd-item__more" data-ctd-more></div></li>';
    }
    function renderList(note) {
      var body = q('[data-ctd-body]'), count = q('[data-ctd-count]');
      st.view = 'list';
      if (!st.list) { count.textContent = ''; body.innerHTML = '<p class="cte-note">Cargando tus diseños…</p>'; return; }
      count.textContent = st.list.length + ' de ' + st.cupo.max + ' diseños guardados' + (st.cupo.lleno ? ' (máximo alcanzado: borra alguno para guardar uno nuevo)' : '') + '.';
      body.innerHTML = (note ? '<p class="cte-note cte-note--warn" role="alert">' + esc(note) + '</p>' : '') +
        (st.list.length ? '<ul class="ctd-list">' + st.list.map(itemHtml).join('') + '</ul>'
          : '<p class="cte-note">Aún no has guardado ningún diseño. Usa «Guardar diseño» en el editor para guardarlo aquí.</p>');
    }
    function openList(opener) {
      renderList();
      openSheet(listSheet, opener);
      loadList().then(function () { if (listIdle()) renderList(); }).catch(function (err) {
        if (!listIdle()) return;
        q('[data-ctd-body]').innerHTML = '<p class="cte-note cte-note--warn" role="alert">' + esc(err.userFacing ? err.message : 'No se han podido cargar tus diseños.') + '</p>';
      });
    }
    /* La lista se refresca al abrir el panel: solo se repinta si el cliente aún no ha empezado otra acción. */
    function listIdle() {
      return st.view === 'list' && !Array.prototype.some.call(listSheet.querySelectorAll('[data-ctd-more]'), function (m) { return m.innerHTML; });
    }
    function byId(id) { return (st.list || []).filter(function (d) { return d.id === id; })[0] || null; }
    function more(li, html) {
      Array.prototype.forEach.call(listSheet.querySelectorAll('[data-ctd-more]'), function (m) { m.innerHTML = ''; });
      var m = li.querySelector('[data-ctd-more]');
      m.innerHTML = html;
      var f = m.querySelector('input, button');
      if (f) f.focus();
      return m;
    }
    function itemError(li, err) {
      more(li, '<p class="cte-note cte-note--warn" role="alert">' + esc(err && err.userFacing ? err.message : 'No se ha podido completar la acción.') + '</p>');
    }
    function zoneNames(ids, typeRaw) { return DM.joinList(ids.map(function (id) { return Z.labelOf(id, typeRaw); })); }

    /* Cargar en esta prenda: si hay zonas que aquí no existen, se confirma antes. */
    function askLoad(li, d) {
      getDoc(d).then(function (doc) {
        var lost = DM.lostZones(doc, zoneIds);
        if (!lost.length) return applyDoc(d, doc);
        more(li, '<p class="cte-note cte-note--warn">Esta prenda no tiene ' + esc(zoneNames(lost, doc.zonas)) + ': esa parte del diseño no se cargará.</p>' +
          '<div class="ctd-row"><button type="button" class="ctd-btn ctd-btn--main" data-ctd-confirm="cargar">Cargar igualmente</button>' +
          '<button type="button" class="ctd-btn" data-ctd-cancel>Cancelar</button></div>');
      }).catch(function (err) { itemError(li, err); });
    }
    function applyDoc(d, doc) {
      return root.cteApplyDesign(doc).then(function (r) {
        st.loaded = { id: d.id, nombre: d.nombre };
        closeSheet();
        var parts = ['Diseño «' + d.nombre + '» cargado.'];
        if (r.perdidas.length) parts.push('Esta prenda no tiene ' + zoneNames(r.perdidas, doc.zonas) + ': esa parte no se ha cargado.');
        parts = parts.concat(r.avisos);
        msg(parts.join(' '), parts.length > 1 ? 'warn' : 'ok');
        q('[data-cte-stage]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    function askRename(li, d) {
      more(li, '<form class="ctd-row" data-ctd-rename><label class="cte-visually-hidden" for="ctd-rn-' + esc(d.id) + '">Nuevo nombre</label>' +
        '<input id="ctd-rn-' + esc(d.id) + '" class="cte-input" maxlength="80" value="' + esc(d.nombre) + '">' +
        '<button type="submit" class="ctd-btn ctd-btn--main">Guardar nombre</button><button type="button" class="ctd-btn" data-ctd-cancel>Cancelar</button></form>');
      var input = li.querySelector('[data-ctd-rename] input');
      input.select();
    }
    function doRename(li, d, nombre) {
      var clean = nombre.replace(/\s+/g, ' ').trim();
      if (!clean) return;
      api('POST', null, { action: 'renombrar', id: d.id, nombre: clean }).then(function (j) {
        setList(j);
        if (st.loaded && st.loaded.id === d.id) st.loaded = { id: d.id, nombre: j.diseno.nombre };
        renderList();
        var again = listSheet.querySelector('.ctd-item[data-id="' + CSS.escape(d.id) + '"] [data-ctd-act="renombrar"]');
        if (again) again.focus();
      }).catch(function (err) { itemError(li, err); });
    }
    function askDelete(li, d) {
      more(li, '<p class="cte-note cte-note--warn">¿Borrar «' + esc(d.nombre) + '»? No se puede deshacer.</p>' +
        '<div class="ctd-row"><button type="button" class="ctd-btn ctd-btn--danger" data-ctd-confirm="borrar">Sí, borrar</button>' +
        '<button type="button" class="ctd-btn" data-ctd-cancel>Cancelar</button></div>');
    }
    function doDelete(li, d) {
      api('POST', null, { action: 'borrar', id: d.id }).then(function (j) {
        setList(j);
        if (st.loaded && st.loaded.id === d.id) st.loaded = null;
        renderList();
        var first = listSheet.querySelector('[data-ctd-act]') || listSheet.querySelector('[data-ctd-close]');
        if (first) first.focus();
      }).catch(function (err) { itemError(li, err); });
    }

    /* ---------- usar en otra prenda ---------- */
    function readyPrendas(list) {
      return list.filter(function (p) { return p.listo && PR.get(p.prenda).ready && Z.zonesFor(p.zonas).calibrado; });
    }
    function productUrl(handle, id) {
      var u = new URL('/products/' + encodeURIComponent(handle), window.location.origin), cur = new URLSearchParams(window.location.search);
      u.searchParams.set('diseno', id);
      if (cur.get('preview_theme_id')) u.searchParams.set('preview_theme_id', cur.get('preview_theme_id'));
      return u.pathname + u.search;
    }
    function openOtra(d) {
      st.view = 'otra';
      st.otra = { d: d, doc: null };
      var body = q('[data-ctd-body]');
      body.innerHTML = '<button type="button" class="cte-link" data-ctd-back>Volver a mis diseños</button><p class="cte-note">Cargando prendas…</p>';
      Promise.all([getDoc(d), st.prendas ? Promise.resolve(st.prendas) : api('GET', { op: 'prendas' }).then(function (j) { st.prendas = j.prendas; return j.prendas; })])
        .then(function (r) {
          st.otra.doc = r[0];
          var list = readyPrendas(r[1]);
          body.innerHTML = '<button type="button" class="cte-link" data-ctd-back>Volver a mis diseños</button>' +
            '<p class="cte-note">Elige la prenda en la que quieres usar «' + esc(d.nombre) + '». El diseño está en centímetros: se coloca con las medidas de la nueva prenda y, si algo no cabe, se ajusta al máximo y te avisamos.</p>' +
            (list.length ? '<ul class="ctd-list">' + list.map(function (p) {
              var same = p.handle === data.handle;
              return '<li class="ctd-item ctd-item--p" data-handle="' + esc(p.handle) + '">' +
                (p.imagen ? '<img class="ctd-item__img" src="' + esc(p.imagen) + '" alt="" loading="lazy" width="96" height="64">' : '<span class="ctd-item__img"></span>') +
                '<div class="ctd-item__t"><b>' + esc(p.titulo) + '</b><span class="cte-note">' + esc(prendaLabel(p.prenda)) + (same ? ' · esta prenda' : '') + '</span></div>' +
                '<div class="ctd-item__acts"><button type="button" class="ctd-btn ctd-btn--main" data-ctd-pick>Abrir con este diseño</button></div>' +
                '<div class="ctd-item__more" data-ctd-more></div></li>';
            }).join('') + '</ul>' : '<p class="cte-note">Ahora mismo no hay otras prendas listas para personalizar.</p>');
          var f = body.querySelector('[data-ctd-pick]') || body.querySelector('[data-ctd-back]');
          if (f) f.focus();
        }).catch(function (err) {
          body.innerHTML = '<button type="button" class="cte-link" data-ctd-back>Volver a mis diseños</button><p class="cte-note cte-note--warn" role="alert">' +
            esc(err.userFacing ? err.message : 'No se han podido cargar las prendas.') + '</p>';
        });
    }
    function pickPrenda(li) {
      var p = (st.prendas || []).filter(function (x) { return x.handle === li.dataset.handle; })[0];
      if (!p || !st.otra) return;
      var lost = DM.lostZones(st.otra.doc, Z.zonesFor(p.zonas).zonas.map(function (z) { return z.id; }));
      var url = productUrl(p.handle, st.otra.d.id);
      if (!lost.length) { window.location.href = url; return; }
      more(li, '<p class="cte-note cte-note--warn">' + esc(p.titulo) + ' no tiene ' + esc(zoneNames(lost, st.otra.doc.zonas)) + ': esa parte del diseño se perderá.</p>' +
        '<div class="ctd-row"><a class="ctd-btn ctd-btn--main" href="' + esc(url) + '">Abrir igualmente</a>' +
        '<button type="button" class="ctd-btn" data-ctd-cancel>Cancelar</button></div>');
    }

    /* ---------- eventos ---------- */
    q('[data-ctd-open]').addEventListener('click', function (e) { openList(e.currentTarget); });
    q('[data-ctd-save]').addEventListener('click', function (e) {
      openSave(e.currentTarget);
      if (!st.list) loadList().catch(function () { return null; }); /* para saber si la lista está llena */
    });
    [saveSheet, listSheet].forEach(function (sheet) {
      sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeSheet(); } });
      sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('[data-ctd-close]')) closeSheet(); });
    });
    saveSheet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ctd-do]');
      if (b && !b.disabled && !st.busy) doSave(b.dataset.ctdDo);
    });
    q('[data-ctd-name]').addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var b = saveSheet.querySelector('[data-ctd-do]:not([disabled])');
      if (b && !st.busy) doSave(b.dataset.ctdDo);
    });
    listSheet.addEventListener('click', function (e) {
      var t = e.target, li = t.closest('.ctd-item'), el;
      if (t.closest('[data-ctd-back]')) return renderList();
      if (t.closest('[data-ctd-cancel]') && li) { li.querySelector('[data-ctd-more]').innerHTML = ''; return; }
      if (li && t.closest('[data-ctd-pick]')) return pickPrenda(li);
      var d = li && byId(li.dataset.id);
      if (!d) return;
      if ((el = t.closest('[data-ctd-confirm]'))) {
        if (el.dataset.ctdConfirm === 'borrar') return doDelete(li, d);
        return getDoc(d).then(function (doc) { return applyDoc(d, doc); }).catch(function (err) { itemError(li, err); });
      }
      if (!(el = t.closest('[data-ctd-act]'))) return;
      var act = el.dataset.ctdAct;
      if (act === 'cargar') return askLoad(li, d);
      if (act === 'renombrar') return askRename(li, d);
      if (act === 'borrar') return askDelete(li, d);
      if (act === 'otra') return openOtra(d);
    });
    listSheet.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-ctd-rename]');
      if (!f) return;
      e.preventDefault();
      var li = f.closest('.ctd-item'), d = li && byId(li.dataset.id);
      if (d) doRename(li, d, f.querySelector('input').value);
    });

    /* ---------- ?diseno=<id>: llega desde «Usar en otra prenda» y carga el diseño ---------- */
    var wanted = new URLSearchParams(window.location.search).get('diseno');
    if (wanted) {
      msg('Cargando el diseño…');
      api('GET', { id: wanted }).then(function (j) {
        return getDoc(j.diseno).then(function (doc) { return applyDoc(j.diseno, doc); });
      }).then(function () {
        var u = new URL(window.location.href);
        u.searchParams.delete('diseno');
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      }).catch(function (err) {
        msg(err && err.userFacing ? err.message : 'No se ha podido cargar el diseño.', 'warn');
      });
    }
    root.cteDisenos = { state: function () { return JSON.parse(JSON.stringify({ loaded: st.loaded, cupo: st.cupo })); } };
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-cte].is-mounted'), init); }
  scan();
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });
})();
